import { useTheme } from '../../contexts/ThemeContext.jsx';
import { THEMES } from '../../utils/constants.js';
import SunIcon from '../../assets/icons/sun.svg?react';
import MoonIcon from '../../assets/icons/moon.svg?react';
import './ThemeToggle.css';

const ThemeToggle = ({ collapsed = false }) => {
  const { theme, currentTheme, toggleTheme, setTheme, isDark, isSystem } = useTheme();

  const handleLightMode = () => {
    setTheme(THEMES.LIGHT);
  };

  const handleDarkMode = () => {
    setTheme(THEMES.DARK);
  };

  const handleToggle = () => {
    toggleTheme();
  };

  // 축소 버전: 현재 테마만 표시하고 클릭하면 토글
  if (collapsed) {
    return (
      <div className="theme-toggle-segment collapsed">
        <button 
          className="theme-segment-option collapsed"
          onClick={handleToggle}
          aria-label={`현재 테마: ${isDark ? '다크' : '라이트'} 모드`}
          title={`현재 테마: ${isDark ? '다크' : '라이트'} 모드 (클릭하여 변경)`}
        >
          {isDark ? <MoonIcon className="theme-icon" /> : <SunIcon className="theme-icon" />}
        </button>
      </div>
    );
  }

  // 전체 버전: 라이트/다크 버튼 모두 표시
  return (
    <div className="theme-toggle-segment">
      <button 
        className={`theme-segment-option ${!isDark ? 'active' : ''}`}
        onClick={handleLightMode}
        aria-label="라이트 모드"
        title="라이트 모드"
      >
        <SunIcon className="theme-icon" />
        <span>Light</span>
      </button>
      <button 
        className={`theme-segment-option ${isDark ? 'active' : ''}`}
        onClick={handleDarkMode}
        aria-label="다크 모드"
        title="다크 모드"
      >
        <MoonIcon className="theme-icon" />
        <span>Dark</span>
      </button>
    </div>
  );
};

export default ThemeToggle; 